module.exports = __webpack_public_path__ + "img/energy.23c6c02e.jpg";